import React from 'react';
import { useLocation } from 'react-router-dom';
import { getPublicPageSeo } from '../../../seo/publicPages';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './ContactHero.css';

const SECTION = 'Contact Us';

const ContactHero = () => {
  const { pathname } = useLocation();
  const heading = getPublicPageSeo(pathname)?.heading || 'Contact Us';
  const { hasDynamicBanner, banners } = usePageBanners(SECTION);
  const titleSectionClass = hasDynamicBanner
    ? 'contact-hero-title-section contact-hero-title-section--below-banner'
    : 'contact-hero-title-section contact-hero-title-section--standalone';

  return (
    <section className="contact-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      <div className={titleSectionClass}>
        <div className="container">
          <div className="contact-hero-content">
            <h1 className="contact-title">
                Contact Us
            </h1>
            <p className="contact-subtitle">
              We'd love to hear from you
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
